import { IonContent, IonPage, IonCol, IonRow, IonText, IonGrid } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import PageHeader from '../../components/PageHeader/PageHeader';
import './AppInfoPage.scss';
import IRouteInfo from '../../interfaces/IRouteInfo';
import AppInfo from '../../data/AppInfo';
import Parser from 'ua-parser-js';
import { isPlatform } from '@ionic/core';

const AppInfoPage: React.FC<IRouteInfo> = (props: IRouteInfo) => {
  const unknown = 'UNKNOWN';
  const [osVersion, setOsVersion] = useState(unknown);
  const [os, setOs] = useState(unknown);
  const [platform, setPlatform] = useState(unknown);
  const [browser, setBrowser] = useState(unknown);
  const [browserVersion, setBrowserVersion] = useState(unknown);
  const [deviceVendor, setDeviceVendor] = useState(unknown);
  const [deviceModel, setDeviceModel] = useState(unknown);

useEffect(() => {
    const result = Parser(window.navigator.userAgent);
    setOs(result.os.name ?? unknown);
    setOsVersion(result.os.version ?? unknown);
    if(isPlatform('hybrid')) {
      if(isPlatform('ios')) {
        setPlatform('iOS - Apple App Store' ?? unknown);
      } else {
        setPlatform('Android App' ?? unknown);
      }
    } else {
      setPlatform('PWA - Web App')
    }
    setBrowser(result.browser.name ?? unknown);
    setBrowserVersion(result.browser.version ?? unknown);
    setDeviceModel(result.device.model ?? unknown);
    setDeviceVendor(result.device.vendor ?? unknown);
    return () => {}
  }, []);

  return (
    <IonPage>
      <PageHeader {...props} showBackButton={true} ></PageHeader>
      <IonContent className="app-information-page">
        <IonGrid fixed={true}>
          <IonRow >
            <IonCol className="announcement-text">
              <IonText color="medium">
                <b>Device:</b><br />
                {deviceVendor} - {deviceModel} 
              </IonText>
            </IonCol>
          </IonRow>
          <IonRow >
            <IonCol className="announcement-text">
              <IonText color="medium">
                <b>Device OS Version:</b><br />
                {os} - {osVersion} 
              </IonText>
            </IonCol>
          </IonRow>
          <IonRow >
            <IonCol className="announcement-text">
              <IonText color="medium">
                <b>Device Browser:</b><br />
                {browser} - {browserVersion} 
              </IonText>
            </IonCol>
          </IonRow>
          <IonRow >
            <IonCol className="announcement-text">
              <IonText color="medium">
                <b>App Platform:</b><br />
                {platform}
                </IonText>
            </IonCol>
          </IonRow>
          <IonRow >
            <IonCol className="announcement-text">
              <IonText color="medium">
                <b>App Release Version:</b><br />
                {AppInfo.version}
              </IonText>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default AppInfoPage;